import { daysBetweenDates } from '@gonfalon/format/daysBetweenDates';

import { getEndDate } from './getEndDate';
import type { CampaignType } from './types';

export function daysRemaining(campaign: CampaignType) {
  const { endDateTime } = campaign;
  if (!!endDateTime) {
    return daysBetweenDates(getEndDate(campaign), new Date());
  }
  return 0;
}
